import React from 'react';

/* A note when using this component - you will need to pass a fill color if you want anything other than black. */

const IconVisa = props => (
  <svg viewBox="0 0 32 20" {...props}>
    <title>Visa</title>
    <title lang="en">Visa</title>
    <g id="icon-/-card-/-visa" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#025EA3" x="0" y="0" width="32" height="20" rx="2"></rect>
      <path
        d="M10.8992253,7 L8.95727267,12.1214212 L8.75013107,11.0808677 C8.26652881,9.80484887 7.21940351,8.46622538 6,7.923718 L7.77681016,14.5 L9.87676938,14.4990031 L13,7 L10.8992253,7 Z"
        id="Fill-1"
        fill="#FEFEFE"
      ></path>
      <polygon
        id="Fill-3"
        fill="#FEFEFE"
        points="12.5 14.5 13.6547943 7 15.5 7 14.3448265 14.5"
      ></polygon>
      <path
        d="M21.36872,7.09512821 C20.98412,6.93902564 20.37732,6.76958974 19.62452,6.76958974 C17.69912,6.76958974 16.34652,7.81923077 16.33472,9.32076923 C16.32232,10.4327692 17.30192,11.0530769 18.03832,11.4225128 C18.79812,11.800359 19.05212,12.0430256 19.04972,12.3814872 C19.04232,12.8994359 18.44172,13.1353333 17.88352,13.1353333 C17.10552,13.1353333 16.69092,13.0190256 16.05312,12.7314359 L15.80032,12.6081538 L15.52792,14.3384103 C15.98332,14.5535897 16.82372,14.7404615 17.69772,14.7498974 C19.74092,14.7498974 21.07032,13.712359 21.08612,12.1096923 C21.09432,11.227641 20.57432,10.5601538 19.45032,10.0087692 C18.77192,9.65061538 18.35232,9.41307692 18.35852,9.04958974 C18.35912,8.72897436 18.71052,8.38497436 19.47372,8.38497436 C20.11112,8.37410256 20.56952,8.52425641 20.93032,8.68220513 L21.10392,8.77102564 L21.36872,7.09512821 Z"
        id="Fill-5"
        fill="#FEFEFE"
      ></path>
      <path
        d="M24.0182255,11.8363779 C24.1800521,11.4056501 24.7947126,9.73849667 24.7947126,9.73849667 C24.7826958,9.75880838 24.9545364,9.30438361 25.0538754,9.02340493 L25.1836571,9.67039269 C25.1836571,9.67039269 25.5579812,11.4614077 25.6362908,11.8363779 L24.0182255,11.8363779 Z M26.4217905,7 L24.9158822,7 C24.4490286,7 24.0993391,7.13222526 23.8932506,7.62289249 L21,14.5 L23.0468656,14.5 C23.0468656,14.5 23.3817344,13.5746223 23.4574404,13.3715052 C23.6805528,13.3715052 25.6689365,13.3760853 25.9527338,13.3760853 C26.0130182,13.6377479 26.1900661,14.5 26.1900661,14.5 L28,14.5 L26.4217905,7 Z"
        id="Fill-8"
        fill="#FEFEFE"
      ></path>
      <path
        d="M7.28872917,6.65758182 L4.01914583,6.65758182 L3.99997917,6.79012727 C6.54227083,7.42871818 8.21977083,8.99635455 8.91789583,10.85015 L8.20727083,7.30701364 C8.0851875,6.81958182 7.72935417,6.67476364 7.28872917,6.65758182"
        id="Fill-10"
        fill="#F0A434"
      ></path>
    </g>
  </svg>
);

export default IconVisa;
